// calling both current and archived teacher
export const START_FETCH_POSTER = 'START_FETCH_POSTER'
export const SUCCESS_FETCH_POSTER = 'SUCCESS_FETCH_POSTER'
export const FAILED_FETCH_POSTER = 'FAILED_FETCH_POSTER'

export const START_UPDATE_POSTER = 'START_UPDATE_POSTER'
export const SUCCESS_UPDATE_POSTER = 'SUCCESS_UPDATE_POSTER'
export const FAILED_UPDATE_POSTER = 'FAILED_UPDATE_POSTER'

import getPosterList from 'controllers/poster/getPosterList'
import updatePosterCTRL from 'controllers/poster/updatePoster'

export function fetchPosterList(schoolId, poster_state, amount_per_page, page_number){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_POSTER,
    })

    getPosterList(schoolId, poster_state, amount_per_page, page_number)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_POSTER,
        payload: {...result, fetching: false, hasPermission: true}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_POSTER,
        payload: {err, fetching: false, hasPermission: false}
      })
    })
  }
}

export function updatePoster(index, posterId, posterInfo, callback){
  return function(dispatch) {

    dispatch({
      type: START_UPDATE_POSTER,
      payload: {index, posterInfo}

    })

    updatePosterCTRL(posterId, posterInfo)
    .then((result) => {
      dispatch({
        type: SUCCESS_UPDATE_POSTER,
        payload: {...result}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      dispatch({
        type: FAILED_UPDATE_POSTER,
        payload: err
      })
    })
  }
}


const initState = {
  list: []
}

export default function posterList(state = initState, action){
  switch(action.type){
    case START_FETCH_POSTER: {
      return {...state, fetching: true, list: [], count: 0}
    }
    case SUCCESS_FETCH_POSTER: {
      return {
        ...state,
        list: action.payload.result_list,
        count: action.payload.total_amount,
        fetching: action.payload.fetching,
        hasPermission: action.payload.hasPermission,
        school_has_poster: action.payload.school_has_poster
      }
    }
    case FAILED_FETCH_POSTER: {
      return {
        ...state,
        error: action.payload.err,
        fetching: action.payload.fetching,
        hasPermission: action.payload.hasPermission
      }
    }

    // updating
    case START_UPDATE_POSTER: {
      const {index, posterInfo} = action.payload;

      const list = state.list.map((existing, i)=>{
        return index === i ? { ...existing, ...posterInfo } : existing;
      })

      return {
        ...state,
        list
      }
    }

    default: return {...state}
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/ducks.js